/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
//import {useIntl} from 'react-intl'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import { getMark, getQtdMark } from '../../services/markService'
import { Loading } from '../components/Loadings/loading'
import { SearchInputV3 } from '../components/SearchInputV3'
import { useToast } from '../components/Toats'
import { MyPortal } from './my-portal'
import { getCredential } from '../../services/credentialService'
import { getCompanyAllSimple } from '../../services/companyService'
import { useQuery } from 'react-query'
import { useAuth } from '../../modules/auth'
import { SelectGlobal } from '../components/SelectGlobal'
import listLayoutStyles from '../components/ListTableLayout/listTableLayout.module.css'
import toolbarStyles from '../../components/OrderServiceChecklist/OrderServiceToolbar/orderServiceToolbar.module.css'
import styles from './portals.module.css'
//import { MyPortal } from './components/my-portal'

const STATUS_TABS: Array<{value: boolean | null, label: string, qtdKey: string, color: string}> = [
  { value: null, label: 'Todos', qtdKey: 'all', color: 'dark' },
  { value: true, label: 'Ativos', qtdKey: 'active', color: 'success' },
  { value: false, label: 'Desativados', qtdKey: 'notActive', color: 'danger' },
]

const portalsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const PortalPage: FC = () => {
    const { toggleToast } = useToast();
    const [filterMarks, setFilterMarks] = useState<boolean | null>(null);
    const [filterName, setFilterName] = useState<string>('');
    const [selectedCompanyId, setSelectedCompanyId] = useState<string>('');
    const user = useAuth();
    const isAdmin = user.currentUser?.role.slug === 'ADMIN';

    const { data: companies = [], isLoading: companiesLoading } = useQuery<any[]>(
      ['getCompaniesPortals', isAdmin],
      async () => {
        const myCompanies = await getCompanyAllSimple();
        return myCompanies;
      },
      {
        enabled: isAdmin,
        onSuccess: (data) => {
          if (data && data.length > 0) {
            setSelectedCompanyId((current) => current || data[0].id);
          }
        },
        onError: (error) => {
          console.log(error);
          toggleToast('Erro ao buscar as empresas!', 'error');
        },
      }
    )

    const { data: marks = [], isLoading: markLoading, refetch: refreshMarks } = useQuery<any[]>(
      ["getMarks", filterMarks, filterName],
      async () => {
        const myMarks = await getMark(filterMarks, filterName)
        return myMarks;
      },
      {
        keepPreviousData: true,
        onError: (error) => {
          toggleToast("Erro ao buscar os portais!", "error")
        },
      }
    )

    const { 
      data: qtdMarks = {
        all: 0,
        active: 0,
        notActive: 0
      }, isLoading: qtdMarkLoading, refetch: refreshQtdMarks } = useQuery<any>(
      "getQtdMarks",
      async () => {
        const myQtdMarks = await getQtdMark();
        return myQtdMarks;
      },
      {
        onError: (error) => {
          console.log(error)
        },
      }
    )

    const { 
      data: credentials = [], isLoading: credentialsLoading, refetch: refreshCredentials } = useQuery<any>(
      ["getCredentials", isAdmin ? selectedCompanyId : null],
      async () => {
        const myCredentials = await getCredential(undefined, isAdmin ? selectedCompanyId : undefined)
        return myCredentials;
      },
      {
        enabled: !isAdmin || Boolean(selectedCompanyId),
        onError: (error) => {
          console.log(error)
        },
      }
    )

  const isLoadingPortals = markLoading || (isAdmin && (companiesLoading || !selectedCompanyId || credentialsLoading));

  const renderPortal = (mark: any, index: number) => (
    <div key={mark.id ? mark.id : index} className='col-md-3' style={{marginBottom: '1.5rem'}}>
      <MyPortal
        className='card'
        color='dark'
        mark={mark}
        credentials={credentials.filter((credential: any) => credential.mark && credential.mark.sub_name === mark.sub_name)}
        companyId={isAdmin ? selectedCompanyId : undefined}
        refreshCredentials={() => {
          refreshCredentials()
        }}
      />
    </div>
  )

  return (
    <div className='column g-5 g-xl-8'>
      <div className={toolbarStyles.toolbarWrap} style={{marginBottom: '1.5rem', gap: '0.5rem'}}>
        <div className={`${listLayoutStyles.listToolbar} ${listLayoutStyles.listToolbarPanel}`}>
          <div className={listLayoutStyles.listToolbarFilters}>
            <div className={toolbarStyles.searchBox}>
              <SearchInputV3
                className={`form-control form-control-sm ${listLayoutStyles.listSearch}`}
                placeholder='Buscar portal por nome'
                setMySearch={setFilterName}
                style={{width: '100%'}}
              />
            </div>
          </div>

          {isAdmin && (
            <div className={`${listLayoutStyles.listToolbarActions} ${styles.companySelect}`}>
              <SelectGlobal
                itens={companies}
                buttonAll={false}
                textSearch='Buscar por empresa'
                textButtonInit='Selecionar empresa'
                labelKey='corporateName'
                valueKey='id'
                value={selectedCompanyId}
                className='w-100'
                loading={companiesLoading}
                typeIcon='img'
                linkIcon='/media/icons/duotune/general/gen001.svg'
                sizeIconSvg='2'
                imageSize='30px'
                onChange={(value: string) => {
                  setSelectedCompanyId(value)
                }}
              />
            </div>
          )}
        </div>

        <div className={toolbarStyles.statusTabs} role='tablist'>
          {STATUS_TABS.map((tab) => {
            const isActive = filterMarks === tab.value
            const count = qtdMarks && qtdMarks[tab.qtdKey] ? qtdMarks[tab.qtdKey] : 0
            return (
              <button
                key={tab.qtdKey}
                type='button'
                role='tab'
                aria-selected={isActive}
                className={`btn btn-sm ${toolbarStyles.statusTab} ${
                  isActive ? `btn-${tab.color} ${toolbarStyles.statusTabActive}` : 'btn-color-gray-700 btn-active-light'
                }`}
                onClick={() => setFilterMarks(tab.value)}
              >
                <span>{tab.label}</span>
                <span className={`badge ${isActive ? toolbarStyles.statusCountActive : `badge-light-${tab.color}`} ${toolbarStyles.statusCount}`}>
                  {qtdMarkLoading ? '-' : count}
                </span>
              </button>
            )
          })}
        </div>
      </div>

      {isLoadingPortals ? 
        (
          <div style={{display: 'flex', justifyContent: 'center', height: '30rem', alignItems: 'center'}}>
            <Loading myClass='spinner-border' style={{width: '3rem', height: '3rem'}}/>
          </div>
        )
      : 
      marks.length > 0 ? 
        (<div className='row bg-light border border-gray-300 border-dashed' 
            style={{
              width: '100%', 
              margin: '0rem', 
              padding: '1rem', 
              borderRadius: '10px', 
              paddingTop: '2rem'
            }}>
            {marks.map(renderPortal)}
          </div>) 
      : 
        <div className='d-flex justify-content-center bg-light border border-gray-300 border-dashed' style={{padding: '2rem'}}>
          <span className='text-muted fw-semibold text-muted d-block fs-4'>
              {filterName ? `Nenhum portal encontrado para "${filterName}".` : 'Portais não encontrados!'}
          </span>
        </div>
    }
    </div>
  )
}

const PortalsWrapper: FC = () => {
  //const intl = useIntl()

  return (
    <>
      <PageTitle breadcrumbs={portalsBreadcrumbs}>
        Gerenciamento de Portais</PageTitle>
      <PortalPage />
    </>
  )
}

export {PortalsWrapper}
